<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-export
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('006002001') !== -1"
          value="导出"/>
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-select selectTitle="缴费类别" :selectKey="'payCategory'" :selectData="payCategoryList" @search="search" style="margin-right: 10px;"/>
        <input-select selectTitle="缴费方式" :selectKey="'payWay'" :selectData="payWayList" @search="search"/>
      </div>
      <input-search placeholder="缴费人姓名/手机号" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/PayService'
  import {bus} from '../../../utils/bus'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'pay-record',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '缴费服务',
          name: 'pay-record'
        }, {
          value: '缴费记录'
        }],
        exportUrl: '',
        payWayList: [{
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '支付宝'
        }, {
          key: '2',
          label: '微信'
        }, {
          key: '3',
          label: '银行转账'
        }, {
          key: '4',
          label: '线下缴费'
        }],
        payCategoryList: [{
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '租金费'
        }, {
          key: '2',
          label: '物业费'
        }, {
          key: '3',
          label: '电费'
        }, {
          key: '4',
          label: '停车费'
        }, {
          key: '5',
          label: '智慧预约费'
        }],
        tableHead: [{
          prop: 'payPersonName',
          label: '缴费人姓名'
        }, {
          prop: 'payPersonPhone',
          label: '缴费人手机'
        }, {
          prop: 'enterpriseName',
          label: '缴费人所属住户'
        }, {
          prop: 'payCategoryText',
          label: '缴费类别'
        }, {
          prop: 'payAmount',
          label: '金额'
        }, {
          prop: 'payWayText',
          label: '缴费方式'
        }, {
          prop: 'payTime',
          label: '缴费时间'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
          payCategory: '',
          payWay: ''
        }
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes

      this.getPage()
    },
    methods: {
      beforeDownload () {

        this.exportUrl = `${api.exportPayRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&payStatus=${this.requestData.payStatus}`
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getPayRecordPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                if (v.payWay === '1') {
                  v.payWayText = '支付宝'
                } else if (v.payWay === '2') {
                  v.payWayText = '微信'
                } else if (v.payWay === '3') {
                  v.payWayText = '银行转账'
                } else if (v.payWay === '4') {
                  v.payWayText = '线下缴费'
                }
                v.payTime = v.payTime.slice(0, 19)

                if (v.payCategory === '1') {
                  v.payCategoryText = '租金费'
                } else if (v.payCategory === '2') {
                  v.payCategoryText = '物业费'
                } else if (v.payCategory === '3') {
                  v.payCategoryText = '电费'
                } else if (v.payCategory === '4') {
                  v.payCategoryText = '停车费'
                } else if (v.payCategory === '5') {
                  v.payCategoryText = '智慧预约费'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取金额信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/PayService/PayRecord/PayRecord.vue